<template>
  <div v-if="this.isPredictedIncome">
    <div class="remaining-income-prediction">
      <div class="remaining-income-text">
        <img class="notice-icon" id="remaining-income-prediction-edit" :src="require('@/assets/icons/notice-green.png')">
        המערכת מצפה לעוד
        <span class="number">{{ this.remainingIncomePredictionRound }}</span>
        <span class="ils-mark">₪</span>
        הכנסות משתנות
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moneyUtils from '../../../../../../../../utils/money';

export default {
  name: 'RemainingVariableIncome',
  computed: {
    ...mapGetters('cashflowView', ['remainingIncomePrediction', 'isPredictedIncome']),
    remainingIncomePredictionRound() {
      return moneyUtils.formatAmountWithFraction(this.remainingIncomePrediction, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../scss/mixins';

  .remaining-income-prediction {
    margin: 10px 0;
    font-size: 10px;
    font-family: SimplerPro;

    .remaining-income-text {
      display: inline-block;
      width: 250px;
    }

    .number {
      font-weight: bold;
      cursor: pointer;
      font-family: SimplerPro;

    .edit-icon {
      width: 10px;
      height: 10px;
      vertical-align: middle;
    }
    }

    .ils-mark {
      font-weight: bold;
    }

    .notice-icon {
      width: 10px;
      height: 10px;
      vertical-align: middle;
    }

    .edit-income-prediction-input {
      width: 44px;
      border: 0;
      border-bottom: 1px solid $riseup_green;
      color: $riseup-green;
      font-weight: bold;
      outline: none;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    input[type=number] {
      -moz-appearance: textfield;
    }

    .approve-income-prediction {
      width: 54px;
      height: 20px;
      background: $riseup-green;
      color: $riseup_white;
      text-align: center;
      border: 0;
      font-family: SimplerPro;
      font-size: 10px;
      border-radius: 1px;
    }
  }
</style>
